import {
  graphAmethyst,
  graphCambridgeBlue,
  graphChefchaouenBlue,
  graphDodgerBlue,
  graphLightRed,
  graphPacificCyan,
  graphPictonBlue,
  graphSandyBrown,
  graphSilverLakeBlue,
  graphSunglow,
  graphTropicalIndigo,
  graphVerdigris,
} from '../../styles/design-tokens';

export const DEFAULT_CHART_COLORS = [
  graphTropicalIndigo,
  graphLightRed,
  graphPictonBlue,
  graphSandyBrown,
  graphChefchaouenBlue,
  graphCambridgeBlue,
  graphAmethyst,
  graphPacificCyan,
  graphDodgerBlue,
  graphSunglow,
  graphVerdigris,
  graphSilverLakeBlue,
];
